/**
 * Maps sidebar item `builtInId` → emoji for the futuristic sidebar redesign.
 * Used by SidebarTreeItem to render an emoji beside each nav label.
 */
export const SIDEBAR_EMOJI_MAP: Record<string, string> = {
  "/": "🏠",
  "/inventory": "📦",
  "/purchase-orders": "📋",
  "/purchase-orders/shipment-groups": "🚢",
  "/sales": "💰",
  "/invoices": "🧾",
  "/consignment": "🤝",
  "/messages": "💬",
  "/packing": "📸",
  "/packing/pick-list": "📝",
  "/print-pack": "🖨️",
  "/customers": "👥",
  "/companies": "🏢",
  "/customers/merge": "🔀",
  "/suppliers": "🏭",
  "/channels": "📡",
  "/marketplaces/ebay-feedback": "⭐",
  "/social": "📱",
  "/social/compose": "✏️",
  "/social/calendar": "📅",
  "/social/scheduled": "⏰",
  "/social/drafts": "📄",
  "/social/published": "✅",
  "/social/approvals": "👁️",
  "/social/settings": "⚙️",
  "/social/inbox": "📥",
  "/social/audit": "🔍",
  "/integrations": "🔗",
  "/quickbooks": "📑",
  "/expenses": "💳",
  "/stationery": "🖊️",
  "/dropshipping": "🚀",
  "/reports": "📊",
  "/reports/forecasting": "🔮",
  "/reports/intelligence": "✨",
  "/profit-loss": "📈",
  "/sales-performance": "🏆",
  "/reports/advanced": "🧮",
  "/admin": "🛠️",
  "/admin/user-permissions": "🔑",
  "/admin/sidebar-manager": "📐",
  "/title-mappings": "🏷️",
  "/admin/tiktok-mappings": "🎵",
  "/tiktok-shop/products": "📦",
  "/admin/system-health": "💚",
  "/email-center": "📧",
  "/notifications": "🔔",
  "/admin/sales-reallocation": "⚖️",
  "/admin/ebay-sync-runs": "🔄",
  "/admin/image-templates": "🖼️",
  "/admin/audit-log": "📋",
  "/admin/losses": "📉",
  "/admin/activity-log": "📜",
  "/settings": "⚙️",
  "/settings/brand-options": "🎨",
  "/settings/notifications": "🔔",
  "/settings/notification-defaults": "🔔",
  "/settings/notification-thresholds": "📏",
  "/settings/notification-logs": "📋",
  "/tasks": "✅",
  "/tasks/team": "👥",
  "/tasks/projects": "🗂️",
  "/tasks/settings": "⚙️",
  "/scrap": "♻️",
  "/scrap/dashboard": "📊",
  "/scrap/purchases/new": "➕",
  "/scrap/purchases": "🛍️",
  "/scrap/inventory": "📦",
  "/scrap/refining": "⚗️",
  "/scrap/refining/results": "✨",
  "/scrap/reports": "📊",
  "/scrap/settings": "⚙️",
  "/hr": "👤",
  "/hr/staff": "👥",
  "/hr/performance": "📈",
  "/hr/payments": "💵",
  "/hr/me": "🙋",
  "/hr/time-off": "🏖️",
  "/hr/change-requests": "📝",
  "/hr/onboarding-templates": "📋",
  "/hr/settings": "⚙️",
  "/hr/audit": "🔍",
  "/returns": "🔄",
  "/returns/list": "📋",
  "/returns/reports": "📊",
  "/returns/settings": "⚙️",
  "/documents": "📄",
  "/documents/templates": "📝",
  "/documents/generated": "📃",
  "/documents/activity": "📜",
  "/assets": "🏷️",
  "/assets/list": "📋",
  "/warehouse": "🏭",
  "/warehouse/locations": "📍",
  "/postage": "📮",
  "/postage/shipments": "📦",
  "/postage/combined": "🔗",
  "/postage/batch": "📦",
  "/postage/couriers": "🚚",
  "/postage/reports": "📊",
  "/postage/settings": "⚙️",
  "/postage/audit": "🔍",
  "/platform": "🌐",
  "/platform/feature-management": "🎛️",
  "/help": "❓",
};
